import React from 'react'

import { useApp } from 'src/hooks/useApp'
import AppSidebar from '../AppSidebar'
import { DefaultComponentProps } from '../AppProviders/types'

import { Toaster } from 'src/components/shadcn/sonner'
import { SidebarProvider, SidebarTrigger } from 'src/components/shadcn/sidebar'

const MainLayout: React.FC<DefaultComponentProps> = ({ children }) => {
  const { isOpen, setIsOpen, toggleSideBar } = useApp()

  return (
    <SidebarProvider open={isOpen}>
      <AppSidebar setIsOpenSideBar={setIsOpen} />
      <main className="w-full">
        <SidebarTrigger onClick={toggleSideBar} />
        {children}
      </main>
      <Toaster />
    </SidebarProvider>
  )
}

export default MainLayout
